import React, { useCallback, useState } from "react";
import { Button, Modal, Table } from "antd";
import { Declarant } from "../../../../models/Declarant";
import COLUMNS from "../../creatorData/config";
import { Log } from "../../../../models/Log";

interface Props {
  entity: Declarant;
}

const CreatorColumn: React.FC<Props> = ({ entity }) => {
  const data = (entity?.department_data?.logs || []) as Log[];

  const [visible, setVisible] = useState(false);

  const showModal = useCallback(() => {
    setVisible(true);
  }, []);

  const hideModal = useCallback(() => {
    setVisible(false);
  }, []);

  if (data.length === 0) {
    return <span>{entity.user?.nickname}</span>;
  }

  return (
    <>
      <Button type="link" onClick={showModal} className="btn--np btn--link">
        {entity.user?.nickname}, ...
      </Button>

      <Modal
        visible={visible}
        footer={false}
        onCancel={hideModal}
        className="logs-modal"
      >
        <Table
          className="logs-table"
          rowKey="id"
          dataSource={data}
          columns={COLUMNS}
          pagination={false}
          bordered
        />
      </Modal>
    </>
  );
};

export default CreatorColumn;
